export const SELECT_PASSENGER_FOR_DELETION = 'SELECT_PASSENGER_FOR_DELETION'

export default (passengerId: string) => ({
  type: SELECT_PASSENGER_FOR_DELETION,
  passengerId,
})
